<script setup lang="ts">
/** Phase 17.6: a person's profile picture, or their initials when they have none (or it fails to load). */
import { computed, ref, watch } from 'vue';

const props = withDefaults(defineProps<{ name: string; url?: string | null; size?: 'sm' | 'md' | 'lg' }>(), { url: null, size: 'md' });
const failed = ref(false);
watch(() => props.url, () => (failed.value = false));
const initials = computed(() =>
  (props.name || '?')
    .split(/\s+/)
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase(),
);
const box = computed(() => ({ sm: 'h-6 w-6 text-[10px]', md: 'h-8 w-8 text-xs', lg: 'h-20 w-20 text-xl' })[props.size]);
</script>

<template>
  <img v-if="url && !failed" :src="url" :alt="name" :title="name" class="shrink-0 rounded-full object-cover" :class="box" @error="failed = true" />
  <span v-else class="flex shrink-0 items-center justify-center rounded-full bg-slate-700 font-semibold text-white" :class="box" :title="name" aria-hidden="true">{{ initials }}</span>
</template>
